/* Poudreux — vanilla JS for the static site
 *
 * Initializes:
 *   - Mobile nav drawer

 *   - Sticky add-to-cart bar
 *   - Reveal-on-scroll
 *   - Newsletter form (footer)
 *   - PDP gallery thumbs + plan picker + quantity stepper
 *   - Subscription configurator
 *   - FAQ accordion
 *   - Testimonial picker dots (homepage)
 *
 * All handlers attach by class/data-attribute, so any page can include
 * this file safely — features only initialize if their markup is present.
 */

(function () {
  "use strict";

  // ---------- Mobile nav ----------
  /*function initNav() {
    var toggle = document.querySelector(".nav-toggle");
    var drawer = document.querySelector(".nav-drawer");
    if (!toggle || !drawer) return;
    toggle.addEventListener("click", function () {
      drawer.classList.add("open");
    });
    drawer.addEventListener("click", function (e) {
      if (e.target.classList.contains("close") || e.target.tagName === "A") {
        drawer.classList.remove("open");
      }
    });
  }*/
  function initNav() {
    var toggle = document.querySelector(".nav-toggle");
    var drawer = document.querySelector(".nav-drawer");
    if (!toggle || !drawer) return;

    toggle.addEventListener("click", function () {
      drawer.classList.add("open");
    });

    drawer.addEventListener("click", function (e) {
      var submenuBtn = e.target.closest(".submenu-toggle");
      if (submenuBtn) {
        var item = submenuBtn.closest(".nav-drawer-item");
        var isOpen = item.classList.contains("open");
        item.classList.toggle("open", !isOpen);
        submenuBtn.setAttribute("aria-expanded", String(!isOpen));
        return;
      }

      if (e.target.classList.contains("close") || e.target.tagName === "A") {
        drawer.classList.remove("open");
      }
    });
  }



  // ---------- Sticky cart ----------
  function initStickyCart() {
    var bar = document.querySelector(".sticky-cart");
    if (!bar) return;
    function onScroll() {
      var docH = document.body.scrollHeight;
      var winH = window.innerHeight;
      var y = window.scrollY;
      var visible = y > 700 && y < docH - winH - 600;
      bar.classList.toggle("visible", visible);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // ---------- Reveal on scroll ----------
  function initReveals() {
    var nodes = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window) || !nodes.length) {
      nodes.forEach(function (n) { n.classList.add("in"); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    nodes.forEach(function (n) { obs.observe(n); });
  }

  // ---------- Newsletter form ----------
  function initNewsletter() {
    var form = document.querySelector("[data-newsletter]");
    if (!form) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var email = (form.querySelector('input[type="email"]') || {}).value || "";
      if (!email.trim()) return;
      var confirmation = form.parentElement.querySelector("[data-newsletter-success]");
      form.style.display = "none";
      if (confirmation) confirmation.style.display = "block";
    });
  }

  

  // ---------- PDP plan picker ----------
  /*function initPlanPicker() {
    var group = document.querySelector("[data-plan-picker]");
    if (!group) return;
    var opts = group.querySelectorAll(".opt");
    opts.forEach(function (opt) {
      opt.addEventListener("click", function (event) {
                  
        opts.forEach(function (o) { o.classList.remove("active"); });
        opt.classList.add("active");
        
      });
    });
  }*/
 

  // ---------- PDP quantity stepper + total update ----------
  function initQty() {
    var qty = document.querySelector("[data-qty]");
    if (!qty) return;
    var price = parseFloat(qty.getAttribute("data-price"));
    var minus = qty.querySelector("[data-qty-minus]");
    var plus = qty.querySelector("[data-qty-plus]");
    var numEl = qty.querySelector(".num");
    var totalEls = document.querySelectorAll("[data-qty-total]");
    var n = parseInt(numEl.textContent, 10) || 1;
    function render() {
      numEl.textContent = n;
      totalEls.forEach(function (el) {
        el.textContent = "$" + (price * n).toFixed(0);
      });
    }
    minus && minus.addEventListener("click", function () {
      n = Math.max(1, n - 1);
      render();
    });
    plus && plus.addEventListener("click", function () {
      n = n + 1;
      render();
    });
    render();
  }

  function initPlanPicker() {
    var group = document.querySelector("[data-plan-picker]");
    if (!group) return;

    var opts = group.querySelectorAll(".opt");

    function getPlan(button) {
      if (button.hasAttribute("data-subscription")) {
        return "subscription";
      }

      if (button.hasAttribute("data-onetime")) {
        return "onetime";
      }

      return null;
    }

    // ✅ Initial active plan (FIXED)
    var activeButton = group.querySelector(".opt.active");

    var activeVariant = activeButton.dataset.upsellVariant;

    if (activeButton) {
      window.selectedPlan = getPlan(activeButton);
      window.selectedVariant = activeVariant;

    }

    opts.forEach(function (opt) {
      opt.addEventListener("click", function (event) {
        var button = event.currentTarget;
        var plan = getPlan(button);

        window.selectedPlan = plan;

        opts.forEach(function (o) {
          o.classList.remove("active");
        });

        button.classList.add("active");
        window.selectedVariant = button.dataset.upsellVariant;

        //console.log("PLAN:", window.selectedPlan);
        //console.log("variant:", window.selectedVariant);
      });
    });

    //console.log("INITIAL PLAN:", window.selectedPlan);
    //console.log("INITIAL variant:", activeVariant);
  }
  


  // ---------- Boot ----------
  document.addEventListener("DOMContentLoaded", function () {
    initNav();
    initStickyCart();
    initReveals();
    initNewsletter();
    initPlanPicker();
    initQty();
    
  });
})();

 

class SectionFAQ extends HTMLElement {
  constructor() {
    super();

    this.items = this.querySelectorAll(".faq-item");

    this.init();
    this.initEditorEvents();
  }

  init() {
    if (this.items.length) {
      this.items[0].classList.add("open");
    }

    this.items.forEach((item) => {
      const btn = item.querySelector(".faq-q");

      if (!btn) return;

      btn.addEventListener("click", () => {
        const wasOpen = item.classList.contains("open");

        this.items.forEach((i) => i.classList.remove("open"));

        if (!wasOpen) {
          item.classList.add("open");
        }
      });
    });
  }

  openItem(index) {
    this.items.forEach((item) => item.classList.remove("open"));
    this.items[index]?.classList.add("open");
  }

  initEditorEvents() {
    document.addEventListener("shopify:block:select", (event) => {
      if (!this.contains(event.target)) return;

      this.openItem(Number(event.target.dataset.index));
    });
  }
}

customElements.define("section-faq", SectionFAQ);
class Testimonial extends HTMLElement {
  constructor() {
    super();

    this.dots = this.querySelectorAll(".testimonial-dot");
    this.items = this.querySelectorAll(".testimonial-block-data");

    this.quoteText = this.querySelector(".testimonial-quote");
    this.whoText = this.querySelector(".testimonial-who");
    this.tagText = this.querySelector(".testimonial-tag");

    this.data = [...this.items].map((item) => ({
      quote: item.dataset.quote,
      who: item.dataset.who,
      tag: item.dataset.tag,
    }));

    this.init();
    this.initEditorEvents();
  }

  init() {
    this.dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        this.changeSlide(Number(dot.dataset.index));
      });
    });
  }

  changeSlide(i) {
    const item = this.data[i];
    if (!item) return;

    this.dots.forEach((d) => d.classList.remove("active"));
    this.dots[i]?.classList.add("active");

    this.quoteText.textContent = item.quote;
    this.whoText.textContent = item.who;
    this.tagText.textContent = item.tag;
  }

  initEditorEvents() {
    document.addEventListener("shopify:block:select", (event) => {
      if (!this.contains(event.target)) return;

      this.changeSlide(Number(event.target.dataset.index));
    });
  }
}

customElements.define("section-testimonial", Testimonial);

class MarqueeSection extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector(".marquee-track");

    this.initEditorEvents();
  }

  initEditorEvents() {
    document.addEventListener("shopify:block:select", (event) => {
      if (!this.contains(event.target)) return;

      this.track.style.animationPlayState = "paused";
    });

    document.addEventListener("shopify:block:deselect", (event) => {
      if (!this.contains(event.target)) return;

      this.track.style.animationPlayState = "running";
    });
  }
}

customElements.define("section-marquee", MarqueeSection);

/*
class ProductMainImage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.image = this.querySelector("[data-gallery-main]");

    document.addEventListener(
      "gallery:image-change",
      this.updateImage.bind(this)
    );
  }

  updateImage(event) {
    if (!this.image) return;

    this.image.src = event.detail.src;
  }
   
}
*/

/*
class ProductMainImage extends HTMLElement {
  connectedCallback() {
    this.images = this.querySelectorAll("[data-gallery-image]");

    document.addEventListener(
      "gallery:image-change",
      this.updateImage.bind(this)
    );
  }

  
  updateImage(event) {
    const mediaId = event.detail.mediaId;

    this.images.forEach((item) => {
      const isActive = item.dataset.mediaId === mediaId;

      item.classList.toggle("active", isActive);

      const video = item.querySelector("video");
      if (video) {
        if (isActive) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }

      const iframe = item.querySelector("iframe");
      if (iframe && isActive) {
        const url = new URL(iframe.src);

        if (url.hostname.includes("youtube")) {
          url.searchParams.set("autoplay", "1");
          url.searchParams.set("mute", "1");
        }

        if (url.hostname.includes("vimeo")) {
          url.searchParams.set("autoplay", "1");
          url.searchParams.set("muted", "1");
        }

        iframe.src = url.toString();
      }
    });
  }
}*/
class ProductMainImage extends HTMLElement {
  connectedCallback() {
    this.images = this.querySelectorAll("[data-gallery-image]");

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event.data.variant;

      if (!variant?.featured_media) return;

      this.updateByMediaId(String(variant.featured_media.id));
    });

    document.addEventListener(
      "gallery:image-change",
      this.updateImage.bind(this)
    );
  }

  updateByMediaId(mediaId) {
    this.images.forEach((image) => {
      image.classList.toggle(
        "active",
        image.dataset.mediaId === mediaId
      );
    });

    document
      .querySelectorAll("[data-gallery-thumb]")
      .forEach((thumb) => {
        thumb.classList.toggle(
          "active",
          thumb.dataset.mediaId === mediaId
        );
      });
  }

  updateImage(event) {
    this.updateByMediaId(event.detail.mediaId);

    const mediaId = event.detail.mediaId;
    
    this.images.forEach((item) => {
      const isActive = item.dataset.mediaId === mediaId;

      item.classList.toggle("active", isActive);

      const video = item.querySelector("video");
      if (video) {
        if (isActive) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }

      const iframe = item.querySelector("iframe");
      if (iframe && isActive) {
        const url = new URL(iframe.src);

        if (url.hostname.includes("youtube")) {
          url.searchParams.set("autoplay", "1");
          url.searchParams.set("mute", "1");
        }

        if (url.hostname.includes("vimeo")) {
          url.searchParams.set("autoplay", "1");
          url.searchParams.set("muted", "1");
        }

        iframe.src = url.toString();
      }
    });
  }
}

customElements.define("section-pdp-main", ProductMainImage);

class ProductThumbnail extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.thumbs = this.querySelectorAll("[data-gallery-thumb]");

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener("click", this.onThumbClick.bind(this));
    });
  }

 
  onThumbClick(event) {
    const thumb = event.currentTarget;
    const mediaId = thumb.dataset.mediaId;

    this.thumbs.forEach((item) => item.classList.remove("active"));
    thumb.classList.add("active");

    document.dispatchEvent(
      new CustomEvent("gallery:image-change", {
        detail: {
          mediaId,
        },
      })
    );
  }
}

customElements.define("section-pdp-thumbs", ProductThumbnail);


// ── Add to cart + checkout ─────────────────────────────────────
    /*async function addToCartAndCheckout() {
      var errors = validate();
      if (errors.length) {
        console.error("[Configurator]", errors.join(" | "));
        alert(errors.join("\n"));
        return;
      }
  
      var cta = $("[data-cta]");
      cta.textContent = "Adding to cart…";
      cta.disabled = true;
  
      try {
        await fetch("/cart/clear.js", { method: "POST" });
  
        var plan = PLANS[state.cadence];
  
        var items = [
          {
            id: parseInt(REFILL_VARIANT_ID, 10),
            quantity: 1,
            selling_plan: parseInt(plan.id, 10),
          },
        ];
  
        if (state.includeBrush) {
          items.push({
            id: parseInt(BRUSH_VARIANT_ID, 10),
            quantity: 1,
          });
        }
  
        var res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items }),
        });
  
        if (!res.ok) {
          var body = await res.json();
          throw new Error(body.description || "Cart error");
        }
  
        window.location.href = "/cart";
  
      } catch (err) {
        console.error("[Configurator] Cart error:", err);
        var cta = $("[data-cta]");
        cta.textContent = "Something went wrong — try again";
        cta.disabled = false;
      }
    }*/
/**
 * Adds multiple items to cart and shows all of them in the notification/drawer.
 * @param {Array} items - Array of { id, quantity, selling_plan? }
 */
async function addItemsToCart(items) {
  const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  const isDrawer = cart?.tagName.toLowerCase() === 'cart-drawer';

  const body = { items };

  if (cart) {
    body.sections = cart.getSectionsToRender().map((s) => s.id).join(",");
    body.sections_url = "/";
    cart.setActiveElement(document.activeElement);
  }

  const res = await fetch(window.routes?.cart_add_url || "/cart/add.js", {
    method: "POST",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(body),
  });

  const response = await res.json();

  if (response.status) {
    publish(PUB_SUB_EVENTS.cartError, {
      source: "cart-helper",
      productVariantId: String(items[0]?.id),
      errors: response.errors || response.description,
      message: response.message,
    });
    throw new Error(response.description || "Cart error");
  }

  if (cart) {
    cart.classList.remove("is-empty");

    if (isDrawer) {
      CartPerformance.measure("add:paint-updated-sections", () => {
        cart.renderContents({
          ...response,
          id: response.items[0]?.id,
          sections: response.sections,
        });
      });
    } else {
      // Patch instance only — never touches CartNotification class
      const addedKeys = response.items.map(i => i.key);

      cart.renderContents = function(parsedState) {
        this.cartItemKeys = addedKeys;
        this.getSectionsToRender().forEach((section) => {
          const sectionHTML = parsedState.sections[section.id];
          const el = document.getElementById(section.id);
          if (!el || !sectionHTML) return;

          if (section.multiSelector) {
            const parsed = new DOMParser().parseFromString(sectionHTML, 'text/html');
            el.innerHTML = section.multiSelector
              .map(sel => parsed.querySelector(sel)?.outerHTML || '')
              .join('');
          } else {
            el.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
          }
        });
        if (this.header) this.open();
      };

      cart.getSectionsToRender = function() {
        return [
          {
            id: 'cart-notification-product',
            multiSelector: (this.cartItemKeys || [])
              .map(k => `[id="cart-notification-product-${k}"]`),
          },
          { id: 'cart-notification-button' },
          { id: 'cart-icon-bubble' },
        ];
      };

      CartPerformance.measure("add:paint-updated-sections", () => {
        cart.renderContents(response);
      });
    }

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "cart-helper",
      productVariantId: String(items[0]?.id),
      cartData: response,
    });
  }

  return response;
}
document.addEventListener("DOMContentLoaded", () => {
  /*const announcementBar = document.querySelector('.announcement-bar');
  const header = document.querySelector('nav');
  const body = document.querySelector('body');

  // Only proceed if both header and body exist
  if (!header || !body) return;

  // Calculate the height of the announcement bar if it exists, otherwise 0
  const sticky = announcementBar ? announcementBar.clientHeight : 0;

  function header_scroll() {
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky");
      body.classList.add("sticky-active");
    } else {
      header.classList.remove("sticky");
      body.classList.remove("sticky-active");
    }
  }

  window.addEventListener('scroll', header_scroll);*/
 
});